const styles = `:host{width:1px;border-right:1px solid;border-color:var(--goto-border-color-default);margin-right:.25rem}`;export default styles;